import React from "react";
import { UncontrolledCollapse, Button, CardBody, Card } from "reactstrap";
import VfitPricing from "./VFitPricing";
import PricingFeatures from "./PricingFeatures";
import {
    Trans,
} from "gatsby-plugin-react-i18next";

const PricingPage = () => {
    return (
        <>
            <VfitPricing />
            <PricingFeatures />
            <section className="position-relative section-pdn-1 pl-0 pr-0 faq-wrapper">
                <div className="logo-container">
                    <h2 className="section-heading mb-5 no-br clr49 font-weight-bold">
                        <Trans>FAQ</Trans>
                    </h2>
                    <div id="accordion" className="">
                        {/* <Card>
                            <Button id="faq2">
                                <Trans>What is the minimum number of employees
                                required?</Trans>
                            </Button>
                            <UncontrolledCollapse toggler="#faq2">
                                <CardBody>
                                    <Trans>The minimum licenses to be purchased will be
                                    for 50 employees</Trans>
                                </CardBody>
                            </UncontrolledCollapse>
                        </Card> */}
                        <Card>
                            <Button id="faq3">
                                <Trans>What is the contract duration for a one-time and
                                an annual subscription?</Trans>
                            </Button>
                            <UncontrolledCollapse toggler="#faq3">
                                <CardBody>
                                    <Trans>The contract duration for a one-time
                                    challenge is for 6 weeks and for an annual
                                    subscription is 1 year.</Trans>
                                </CardBody>
                            </UncontrolledCollapse>
                        </Card>
                        <Card>
                            <Button id="faq4">
                                <Trans>Will I be able to move from a one-time plan to
                                an annual plan?</Trans>
                            </Button>
                            <UncontrolledCollapse toggler="#faq4">
                                <CardBody>
                                    <Trans>Yes. Once the one time challenge ends, our
                                    team will help you to upgrade to an annual
                                    plan.</Trans>
                                </CardBody>
                            </UncontrolledCollapse>
                        </Card>
                        <Card>
                            <Button id="faq5">
                                <Trans>How long does it take to implement the program?</Trans>
                            </Button>
                            <UncontrolledCollapse toggler="#faq5">
                                <CardBody>
                                    <Trans>Once the contract is signed, we can launch
                                    the program in 2 weeks for a one-time
                                    challenge and 4 weeks in case of an annual
                                    subscription.</Trans>
                                </CardBody>
                            </UncontrolledCollapse>
                        </Card>
                        <Card>
                            <Button id="faq6">
                                <Trans>What to do if I want to run two one-time
                                challenges?</Trans>
                            </Button>
                            <UncontrolledCollapse toggler="#faq6">
                                <CardBody>
                                    <Trans>You can run two one-time challenges, but we
                                    will suggest to move to an annual plan if
                                    you are planning on running multiple
                                    challenges.</Trans>
                                </CardBody>
                            </UncontrolledCollapse>
                        </Card>
                        <Card>
                            <Button id="faq7">
                                <Trans>Will I get a discount if my employee count is
                                more than 1000?</Trans>
                            </Button>
                            <UncontrolledCollapse toggler="#faq7">
                                <CardBody>
                                    <Trans>Yes. If your employee count is more than
                                    1000, then you can connect with our team for
                                    a custom pricing.</Trans>
                                </CardBody>
                            </UncontrolledCollapse>
                        </Card>
                    </div>
                </div>
            </section>
        </>
    );
};

export default PricingPage;
